import { NavLink } from 'react-router-dom';
import { MobillsIcon } from '@/components/ui/MobillsIcon';
import { NAV } from '@/nav';
import { cn } from '@/lib/cn';
import { Fab } from './Fab';

/** Rail desktop. A identidade global usa primary; teal fica restrito a cartões. */
export function Sidebar({ onFab, onSupport }: { onFab?: (anchor: DOMRect) => void; onSupport?: () => void }) {
  return (
    <aside className="fixed inset-y-0 left-0 z-30 hidden w-20 flex-col items-center border-r border-border bg-surface py-4 lg:flex">
      {/* logo */}
      <div className="grid size-11 place-items-center rounded-2xl bg-primary text-lg font-bold text-white">
        L
      </div>

      <div className="mt-4">
        <Fab onClick={onFab} size="lg" />
      </div>

      <nav className="mt-4 flex min-h-0 flex-1 flex-col items-center gap-0">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            title={label}
            className="group relative grid w-full place-items-center py-1"
          >
            {({ isActive }) => (
              <>
                <span
                  className={cn(
                    'absolute -left-px h-7 w-1 rounded-r-full bg-primary transition-opacity',
                    isActive ? 'opacity-100' : 'opacity-0',
                  )}
                />
                <span
                  data-nav-glyph
                  className={cn(
                    'grid size-9 place-items-center rounded-lg transition-colors',
                    isActive
                      ? 'bg-primary-weak text-primary'
                      : 'text-muted group-hover:bg-canvas group-hover:text-ink',
                  )}
                >
                  <Icon className="size-5" />
                </span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="flex flex-col items-center gap-1">
        <NavLink
          to="/config"
          title="Configurações"
          className={({ isActive }) =>
            cn(
              'grid size-11 place-items-center rounded-xl transition-colors',
              isActive ? 'bg-primary-weak text-primary' : 'text-muted hover:bg-canvas hover:text-ink',
            )
          }
        >
          <MobillsIcon name="settings" className="size-[1.375rem]" />
        </NavLink>
        <button
          type="button"
          title="Reportar problema"
          aria-label="Reportar problema"
          onClick={onSupport}
          className="grid size-11 place-items-center rounded-xl text-muted transition-colors hover:bg-canvas hover:text-ink"
        >
          <MobillsIcon name="help" className="size-[1.375rem]" />
        </button>
      </div>
    </aside>
  );
}
